module.exports = __webpack_public_path__ + "static/img/7.57ffb4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/sp/7.png
// module id = ASFO
// module chunks = 0